import dayjs from "dayjs";
import React from "react";
import {
  ContainerBuble,
  TooltipBox,
  TooltipContainer,
  ImageAvatar,
  Buble,
  TextChat,
  ImageChat,
  ContainerMetting,
  ButtonLink,
  NewCaseText,
} from "./index.style";
import { MdPhone } from "react-icons/md";
import { useImageModal } from "../../../store/ImageModal";
import { imageError } from "../../../functions/error";

interface IChatProps {
  url?: string;
  blob?: Blob;
  text?: string;
  videoUrl?: string;
  isMe?: boolean;
  avatarUser?: string;
  timestamp?: string | number | Date;
  meetingRoomUrl?: string;
  type?: string;
}
const ChatItem = (props: IChatProps) => {
  const { setUrl } = useImageModal();
  if (props.type === "newcase") return <NewCaseText>{props.text}</NewCaseText>;
  return !props.text &&
    !props.url &&
    !props.videoUrl &&
    !props.meetingRoomUrl ? (
    <></>
  ) : (
    <Tooltip text={dayjs().format("lll")} isme={props.isMe}>
      <ContainerBuble isme={props.isMe}>
        {!props.isMe && props.avatarUser && (
          <ImageAvatar
            alt="alvatar"
            src={props.avatarUser}
            onClick={() => props.avatarUser && setUrl([props.avatarUser])}
            onError={imageError}
          />
        )}
        <Buble isme={props.isMe}>
          {props.text && <TextChat isme={props.isMe}>{props.text}</TextChat>}
          {props.videoUrl && (
            <video width={256} controls>
              <source src={props.videoUrl} type="video/mp4" />
            </video>
          )}
          {props.url && (
            <ImageChat
              onClick={() => props.url && setUrl([props.url])}
              src={props.url}
              onError={imageError}
            />
          )}
          {props.meetingRoomUrl && (
            <ContainerMetting>
              <TextChat
                style={{ fontSize: "1.5rem", textAlign: "center" }}
                isme={props.isMe}
              >
                คำขอการโทรจาก Pettinee
              </TextChat>
              <MdPhone size={100} color="white" style={{ margin: "0 auto" }} />
              <ButtonLink href={props.meetingRoomUrl}>เข้าลิงค์</ButtonLink>
            </ContainerMetting>
          )}
        </Buble>
      </ContainerBuble>
    </Tooltip>
  );
};
const Tooltip = ({
  children,
  text,
  isme,
  ...rest
}: {
  children: JSX.Element;
  text: string;
  isme?: boolean;
  rest?: any;
}) => {
  const [show, setShow] = React.useState(false);
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: isme ? "flex-end" : "flex-start",
      }}
    >
      <TooltipContainer>
        <TooltipBox isme={isme} show={show}>
          {text}
        </TooltipBox>
        <div
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
          {...rest}
        >
          {children}
        </div>
      </TooltipContainer>
    </div>
  );
};

export default ChatItem;
